import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-926d577c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "intro__background_images",
  ref: "container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageStreamsCount, (index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `imagestream-${index}`,
        class: "backgroundimage__stream"
      }, [
        (_ctx.images[index - 1])
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.images[index - 1],
              class: "backgroundimage__image"
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, "Geen image"))
      ]))
    }), 128))
  ], 512))
}